import type { ArticleListItem } from 'types/capi/shared';

import Tracked from '~/components/Tracked';
import useRegion from '~/hooks/useRegion';

import ArticleCard from './ArticleCard';
import toArticleCard from './ArticleCard/transformer';

const MODULE_TYPE = 'related-articles';

type RecommendedArticlesProps = {
  articles: ArticleListItem[];
  heading?: string;
  viewMoreNewsPath?: string;
};

export default function RecommendedArticles({
  heading = 'Related articles',
  articles,
  viewMoreNewsPath
}: RecommendedArticlesProps) {
  const region = useRegion();

  if (articles.length === 0 || region.code !== 'GB') return null;

  return (
    <div className="content-width flex flex-col items-center gap-6 py-12">
      <div className="flex w-full max-w-[552px] items-center justify-between lg:max-w-none">
        <h3 className="text-title-sm">{heading}</h3>
        <Tracked.ExternalLink
          variant="none"
          name="RELATED_ARTICLES"
          pagePosition="Body"
          href={viewMoreNewsPath ? viewMoreNewsPath : '/news/'}
          className="text-sm underline hover:text-gray-600"
          data-page_position="Body"
        >
          View more news
        </Tracked.ExternalLink>
      </div>
      <div className="flex flex-col items-center justify-center">
        <div className="grid max-w-[552px] grid-cols-1 gap-6 lg:max-w-none lg:grid-cols-3">
          {articles.map((article, idx) => {
            return (
              <ArticleCard
                key={`article-${idx}`}
                item={toArticleCard(article)}
                moduleType={MODULE_TYPE}
                pagePosition="Body"
                name="RELATED_ARTICLES"
                position={idx + 1}
                variant="16/9-text-under"
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
